import { PlanFeatureIconVariant } from './types';

const variantToSrcMap: { [key in PlanFeatureIconVariant]: string } = {
  allowed: 'images/icons/allowed.svg',
  forbidden: 'images/icons/forbidden.svg',
  unlimited: 'images/icons/unlimited.svg'
};

export const getIconSrc = (variant: PlanFeatureIconVariant) =>
  variantToSrcMap[variant];
